const brasil = [
  {
    id: 0,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 26/27 - Uniforme 1",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/26-27-01/uni0.jpg",
      "/images/selecaobrasileira/26-27-01/uni1.jpg",
      "/images/selecaobrasileira/26-27-01/uni2.jpg",
      "/images/selecaobrasileira/26-27-01/uni3.jpg",
      "/images/selecaobrasileira/26-27-01/uni4.jpg",
    ],
  },
  {
    id: 1,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 26/27 - Uniforme 2",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/26-27-02/uni0.jpg",
      "/images/selecaobrasileira/26-27-02/uni1.jpg",
      "/images/selecaobrasileira/26-27-02/uni2.jpg",
      "/images/selecaobrasileira/26-27-02/uni3.jpg",
      "/images/selecaobrasileira/26-27-02/uni4.jpg",
    ],
  },
  {
    id: "01",
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 26/27 - Uniforme 1",
    aliases: [
      "brasil",
      "seleção",
      "feminino",
      "feminina",
      "seleção brasileira feminino",
      "feminino seleção brasileira ",
      "seleção brasileira",
      "canarinho",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/26-27-01-f/uni0.jpg",
      "/images/selecaobrasileira/26-27-01-f/uni1.jpg",
      "/images/selecaobrasileira/26-27-01-f/uni2.jpg",
      "/images/selecaobrasileira/26-27-01-f/uni3.jpg",
      "/images/selecaobrasileira/26-27-01-f/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 26/27 - Uniforme 2",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/26-27-02-f/uni0.jpg",
      "/images/selecaobrasileira/26-27-02-f/uni1.jpg",
      "/images/selecaobrasileira/26-27-02-f/uni2.jpg",
      "/images/selecaobrasileira/26-27-02-f/uni3.jpg",
      "/images/selecaobrasileira/26-27-02-f/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 26/27 - Uniforme Edição Especial (Feminino)",
    aliases: [
      "brasil",
      "seleção",
      "feminino",
      "seleção brasileira",
      "canarinho",
      "feminino brasil",
      "brasil feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/26-27-00-esf/uni0.jpg",
      "/images/selecaobrasileira/26-27-00-esf/uni1.jpg",
      "/images/selecaobrasileira/26-27-00-esf/uni2.jpg",
      "/images/selecaobrasileira/26-27-00-esf/uni3.jpg",
      "/images/selecaobrasileira/26-27-00-esf/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 25/26 - Uniforme 1",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/25-26-01/uni0.jpg",
      "/images/selecaobrasileira/25-26-01/uni1.jpg",
      "/images/selecaobrasileira/25-26-01/uni2.jpg",
      "/images/selecaobrasileira/25-26-01/uni3.jpg",
      "/images/selecaobrasileira/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 25/26 - Uniforme 2",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/25-26-02/uni0.jpg",
      "/images/selecaobrasileira/25-26-02/uni1.jpg",
      "/images/selecaobrasileira/25-26-02/uni2.jpg",
      "/images/selecaobrasileira/25-26-02/uni3.jpg",
      "/images/selecaobrasileira/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 25/26 - Uniforme 1 (Feminino)",
    aliases: [
      "brasil",
      "seleção",
      "feminino",
      "seleção brasileira",
      "canarinho",
      "feminino brasil",
      "brasil feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/25-26-01-f/uni0.jpg",
      "/images/selecaobrasileira/25-26-01-f/uni1.jpg",
      "/images/selecaobrasileira/25-26-01-f/uni2.jpg",
      "/images/selecaobrasileira/25-26-01-f/uni3.jpg",
      "/images/selecaobrasileira/25-26-01-f/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 25/26 - Uniforme 2 (Feminino)",
    aliases: [
      "brasil",
      "seleção",
      "feminino",
      "seleção brasileira",
      "canarinho",
      "feminino brasil",
      "brasil feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/25-26-02-f/uni0.jpg",
      "/images/selecaobrasileira/25-26-02-f/uni1.jpg",
      "/images/selecaobrasileira/25-26-02-f/uni2.jpg",
      "/images/selecaobrasileira/25-26-02-f/uni3.jpg",
      "/images/selecaobrasileira/25-26-02-f/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 25/26 - Jaqueta (Verde)",
    aliases: [
      "brasil",
      "seleção",
      "jaqueta",
      "seleção brasileira",
      "canarinho",
      "jaqueta brasil",
      "brasil jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/25-26-05-jv/uni0.jpg",
      "/images/selecaobrasileira/25-26-05-jv/uni1.jpg",
      "/images/selecaobrasileira/25-26-05-jv/uni2.jpg",
      "/images/selecaobrasileira/25-26-05-jv/uni3.jpg",
      "/images/selecaobrasileira/25-26-05-jv/uni4.jpg",
    ],
  },
  {
    id: 9,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 24/25 - Calção 1",
    aliases: [
      "brasil",
      "seleção",
      "calção",
      "seleção brasileira",
      "canarinho",
      "calção brasil",
      "brasil calção",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/24-25-01-c/uni0.jpg",
      "/images/selecaobrasileira/24-25-01-c/uni1.jpg",
      "/images/selecaobrasileira/24-25-01-c/uni2.jpg",
      "/images/selecaobrasileira/24-25-01-c/uni3.jpg",
      "/images/selecaobrasileira/24-25-01-c/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 24/25 - Calção 2",
    aliases: [
      "brasil",
      "seleção",
      "calção",
      "seleção brasileira",
      "canarinho",
      "calção brasil",
      "brasil calção",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/24-25-02-c/uni0.jpg",
      "/images/selecaobrasileira/24-25-02-c/uni1.jpg",
      "/images/selecaobrasileira/24-25-02-c/uni2.jpg",
      "/images/selecaobrasileira/24-25-02-c/uni3.jpg",
      "/images/selecaobrasileira/24-25-02-c/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 25/26 - Jaqueta (Branca)",
    aliases: [
      "brasil",
      "seleção",
      "jaqueta",
      "seleção brasileira",
      "canarinho",
      "jaqueta brasil",
      "brasil jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/24-25-05-jb/uni0.jpg",
      "/images/selecaobrasileira/24-25-05-jb/uni1.jpg",
      "/images/selecaobrasileira/24-25-05-jb/uni2.jpg",
      "/images/selecaobrasileira/24-25-05-jb/uni3.jpg",
      "/images/selecaobrasileira/24-25-05-jb/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 23/24 - Uniforme de Treino (Azul)",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/23-24-05-ta/uni0.jpg",
      "/images/selecaobrasileira/23-24-05-ta/uni1.jpg",
      "/images/selecaobrasileira/23-24-05-ta/uni2.jpg",
      "/images/selecaobrasileira/23-24-05-ta/uni3.jpg",
      "/images/selecaobrasileira/23-24-05-ta/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 22/23 - Uniforme Edição Especial",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/22-23-00-esb/uni0.jpg",
      "/images/selecaobrasileira/22-23-00-esb/uni1.jpg",
      "/images/selecaobrasileira/22-23-00-esb/uni2.jpg",
      "/images/selecaobrasileira/22-23-00-esb/uni3.jpg",
      "/images/selecaobrasileira/22-23-00-esb/uni4.jpg",
    ],
  },
  {
    id: 14,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 22/23 - Jaqueta (Cinza)",
    aliases: [
      "brasil",
      "seleção",
      "jaqueta",
      "seleção brasileira",
      "canarinho",
      "jaqueta brasil",
      "brasil jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/22-23-btc/uni0.jpg",
      "/images/selecaobrasileira/22-23-btc/uni1.jpg",
      "/images/selecaobrasileira/22-23-btc/uni2.jpg",
      "/images/selecaobrasileira/22-23-btc/uni3.jpg",
      "/images/selecaobrasileira/22-23-btc/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 21/22 - Uniforme de Pré Jogo (Azul)",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/21-22-05-pja/uni0.jpg",
      "/images/selecaobrasileira/21-22-05-pja/uni1.jpg",
      "/images/selecaobrasileira/21-22-05-pja/uni2.jpg",
      "/images/selecaobrasileira/21-22-05-pja/uni3.jpg",
      "/images/selecaobrasileira/21-22-05-pja/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 21/22 - Uniforme de Pré Jogo (Amarela)",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/21-22-05-pjaa/uni0.jpg",
      "/images/selecaobrasileira/21-22-05-pjaa/uni1.jpg",
      "/images/selecaobrasileira/21-22-05-pjaa/uni2.jpg",
      "/images/selecaobrasileira/21-22-05-pjaa/uni3.jpg",
      "/images/selecaobrasileira/21-22-05-pjaa/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 21/22 - Uniforme de Pré Jogo (Branca)",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/21-22-05-pjb/uni0.jpg",
      "/images/selecaobrasileira/21-22-05-pjb/uni1.jpg",
      "/images/selecaobrasileira/21-22-05-pjb/uni2.jpg",
      "/images/selecaobrasileira/21-22-05-pjb/uni3.jpg",
      "/images/selecaobrasileira/21-22-05-pjb/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 21/22 - Uniforme de Pré Jogo (Cinza)",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/21-22-05-pjc/uni0.jpg",
      "/images/selecaobrasileira/21-22-05-pjc/uni1.jpg",
      "/images/selecaobrasileira/21-22-05-pjc/uni2.jpg",
      "/images/selecaobrasileira/21-22-05-pjc/uni3.jpg",
      "/images/selecaobrasileira/21-22-05-pjc/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 21/22 - Uniforme de Treino (Verde)",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/21-22-05-tv/uni0.jpg",
      "/images/selecaobrasileira/21-22-05-tv/uni1.jpg",
      "/images/selecaobrasileira/21-22-05-tv/uni2.jpg",
      "/images/selecaobrasileira/21-22-05-tv/uni3.jpg",
      "/images/selecaobrasileira/21-22-05-tv/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 20/21 - Uniforme 1",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/20-21-01/uni0.jpg",
      "/images/selecaobrasileira/20-21-01/uni1.jpg",
      "/images/selecaobrasileira/20-21-01/uni2.jpg",
      "/images/selecaobrasileira/20-21-01/uni3.jpg",
      "/images/selecaobrasileira/20-21-01/uni4.jpg",
    ],
  },
  {
    id: 21,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 20/21 - Uniforme 1",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/20-21-02/uni0.jpg",
      "/images/selecaobrasileira/20-21-02/uni1.jpg",
      "/images/selecaobrasileira/20-21-02/uni2.jpg",
      "/images/selecaobrasileira/20-21-02/uni3.jpg",
      "/images/selecaobrasileira/20-21-02/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 20/21 - Uniforme de Treino (Azul)",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/20-21-05-ta/uni0.jpg",
      "/images/selecaobrasileira/20-21-05-ta/uni1.jpg",
      "/images/selecaobrasileira/20-21-05-ta/uni2.jpg",
      "/images/selecaobrasileira/20-21-05-ta/uni3.jpg",
      "/images/selecaobrasileira/20-21-05-ta/uni4.jpg",
    ],
  },
  {
    id: 23,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 20/21 - Uniforme de Goleiro Treino (Verde)",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/20-21-06-gtv/uni0.jpg",
      "/images/selecaobrasileira/20-21-06-gtv/uni1.jpg",
      "/images/selecaobrasileira/20-21-06-gtv/uni2.jpg",
      "/images/selecaobrasileira/20-21-06-gtv/uni3.jpg",
      "/images/selecaobrasileira/20-21-06-gtv/uni4.jpg",
    ],
  },
  {
    id: 24,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 20/21 - Uniforme de Pré Jogo (Cinza)",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/20-21-06-pjc/uni0.jpg",
      "/images/selecaobrasileira/20-21-06-pjc/uni1.jpg",
      "/images/selecaobrasileira/20-21-06-pjc/uni2.jpg",
      "/images/selecaobrasileira/20-21-06-pjc/uni3.jpg",
      "/images/selecaobrasileira/20-21-06-pjc/uni4.jpg",
    ],
  },
  {
    id: 25,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 20/21 - Uniforme 1 (Feminino)",
    aliases: [
      "brasil",
      "seleção",
      "feminino",
      "seleção brasileira",
      "canarinho",
      "feminino brasil",
      "brasil feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/20-21-01-f/uni0.jpg",
      "/images/selecaobrasileira/20-21-01-f/uni1.jpg",
      "/images/selecaobrasileira/20-21-01-f/uni2.jpg",
      "/images/selecaobrasileira/20-21-01-f/uni3.jpg",
      "/images/selecaobrasileira/20-21-01-f/uni4.jpg",
    ],
  },
  {
    id: 26,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 20/21 - Uniforme 2 (Feminino)",
    aliases: [
      "brasil",
      "seleção",
      "feminino",
      "seleção brasileira",
      "canarinho",
      "feminino brasil",
      "brasil feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/20-21-02-f/uni0.jpg",
      "/images/selecaobrasileira/20-21-02-f/uni1.jpg",
      "/images/selecaobrasileira/20-21-02-f/uni2.jpg",
      "/images/selecaobrasileira/20-21-02-f/uni3.jpg",
      "/images/selecaobrasileira/20-21-02-f/uni4.jpg",
    ],
  },
  {
    id: 27,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 19/20 - Uniforme 3",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/19-20-03/uni0.jpg",
      "/images/selecaobrasileira/19-20-03/uni1.jpg",
      "/images/selecaobrasileira/19-20-03/uni2.jpg",
      "/images/selecaobrasileira/19-20-03/uni3.jpg",
      "/images/selecaobrasileira/19-20-03/uni4.jpg",
    ],
  },
  {
    id: 28,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 18/19 - Uniforme 1",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/18-19-01/uni0.jpg",
      "/images/selecaobrasileira/18-19-01/uni1.jpg",
      "/images/selecaobrasileira/18-19-01/uni2.jpg",
      "/images/selecaobrasileira/18-19-01/uni3.jpg",
      "/images/selecaobrasileira/18-19-01/uni4.jpg",
    ],
  },
  {
    id: 29,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 18/19 - Uniforme 2",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/18-19-02/uni0.jpg",
      "/images/selecaobrasileira/18-19-02/uni1.jpg",
      "/images/selecaobrasileira/18-19-02/uni2.jpg",
      "/images/selecaobrasileira/18-19-02/uni3.jpg",
      "/images/selecaobrasileira/18-19-02/uni4.jpg",
    ],
  },
  {
    id: 30,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 14/15 - Uniforme 1 Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/14-15-01-rt/uni0.jpg",
      "/images/selecaobrasileira/14-15-01-rt/uni1.jpg",
      "/images/selecaobrasileira/14-15-01-rt/uni2.jpg",
      "/images/selecaobrasileira/14-15-01-rt/uni3.jpg",
      "/images/selecaobrasileira/14-15-01-rt/uni4.jpg",
    ],
  },
  {
    id: 31,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 14/15 - Uniforme 2 Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/14-15-02-rt/uni0.jpg",
      "/images/selecaobrasileira/14-15-02-rt/uni1.jpg",
      "/images/selecaobrasileira/14-15-02-rt/uni2.jpg",
      "/images/selecaobrasileira/14-15-02-rt/uni3.jpg",
      "/images/selecaobrasileira/14-15-02-rt/uni4.jpg",
    ],
  },
  {
    id: 32,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 12/13 - Uniforme 1 Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/12-13-01-rt/uni0.jpg",
      "/images/selecaobrasileira/12-13-01-rt/uni1.jpg",
      "/images/selecaobrasileira/12-13-01-rt/uni2.jpg",
      "/images/selecaobrasileira/12-13-01-rt/uni3.jpg",
      "/images/selecaobrasileira/12-13-01-rt/uni4.jpg",
    ],
  },
  {
    id: 33,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 10/11 - Uniforme 1 Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/10-11-01-rt/uni0.jpg",
      "/images/selecaobrasileira/10-11-01-rt/uni1.jpg",
      "/images/selecaobrasileira/10-11-01-rt/uni2.jpg",
      "/images/selecaobrasileira/10-11-01-rt/uni3.jpg",
      "/images/selecaobrasileira/10-11-01-rt/uni4.jpg",
    ],
  },
  {
    id: 34,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 10/11 - Uniforme 2 Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/10-11-02-rt/uni0.jpg",
      "/images/selecaobrasileira/10-11-02-rt/uni1.jpg",
      "/images/selecaobrasileira/10-11-02-rt/uni2.jpg",
      "/images/selecaobrasileira/10-11-02-rt/uni3.jpg",
      "/images/selecaobrasileira/10-11-02-rt/uni4.jpg",
    ],
  },
  {
    id: 35,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 06/07 - Uniforme 1 Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/06-07-01-rt/uni0.jpg",
      "/images/selecaobrasileira/06-07-01-rt/uni1.jpg",
      "/images/selecaobrasileira/06-07-01-rt/uni2.jpg",
      "/images/selecaobrasileira/06-07-01-rt/uni3.jpg",
      "/images/selecaobrasileira/06-07-01-rt/uni4.jpg",
    ],
  },
  {
    id: 36,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 04/05 - Uniforme 1 Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/04-05-01-rt/uni0.jpg",
      "/images/selecaobrasileira/04-05-01-rt/uni1.jpg",
      "/images/selecaobrasileira/04-05-01-rt/uni2.jpg",
      "/images/selecaobrasileira/04-05-01-rt/uni3.jpg",
      "/images/selecaobrasileira/04-05-01-rt/uni4.jpg",
    ],
  },
  {
    id: 37,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 04/05 - Uniforme 2 Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/04-05-02-rt/uni0.jpg",
      "/images/selecaobrasileira/04-05-02-rt/uni1.jpg",
      "/images/selecaobrasileira/04-05-02-rt/uni2.jpg",
      "/images/selecaobrasileira/04-05-02-rt/uni3.jpg",
      "/images/selecaobrasileira/04-05-02-rt/uni4.jpg",
    ],
  },
  {
    id: 38,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 02/03 - Uniforme 1 Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/02-03-01-rt/uni0.jpg",
      "/images/selecaobrasileira/02-03-01-rt/uni1.jpg",
      "/images/selecaobrasileira/02-03-01-rt/uni2.jpg",
      "/images/selecaobrasileira/02-03-01-rt/uni3.jpg",
      "/images/selecaobrasileira/02-03-01-rt/uni4.jpg",
    ],
  },
  {
    id: 39,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 02/03 - Uniforme de Goleiro Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/02-03-05-grt/uni0.jpg",
      "/images/selecaobrasileira/02-03-05-grt/uni1.jpg",
      "/images/selecaobrasileira/02-03-05-grt/uni2.jpg",
      "/images/selecaobrasileira/02-03-05-grt/uni3.jpg",
      "/images/selecaobrasileira/02-03-05-grt/uni4.jpg",
    ],
  },
  {
    id: 40,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 98/99 - Uniforme 1 Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/98-99-01-rt/uni0.jpg",
      "/images/selecaobrasileira/98-99-01-rt/uni1.jpg",
      "/images/selecaobrasileira/98-99-01-rt/uni2.jpg",
      "/images/selecaobrasileira/98-99-01-rt/uni3.jpg",
      "/images/selecaobrasileira/98-99-01-rt/uni4.jpg",
    ],
  },
  {
    id: 41,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 98/99 - Uniforme Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/98-99-02-rt/uni0.jpg",
      "/images/selecaobrasileira/98-99-02-rt/uni1.jpg",
      "/images/selecaobrasileira/98-99-02-rt/uni2.jpg",
      "/images/selecaobrasileira/98-99-02-rt/uni3.jpg",
      "/images/selecaobrasileira/98-99-02-rt/uni4.jpg",
    ],
  },
  {
    id: 42,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 98/99 - Uniforme Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/98-99-05-grt/uni0.jpg",
      "/images/selecaobrasileira/98-99-05-grt/uni1.jpg",
      "/images/selecaobrasileira/98-99-05-grt/uni2.jpg",
      "/images/selecaobrasileira/98-99-05-grt/uni3.jpg",
      "/images/selecaobrasileira/98-99-05-grt/uni4.jpg",
    ],
  },
  {
    id: 43,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 97/98 - Uniforme 1 Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/97-98-01-rt/uni0.jpg",
      "/images/selecaobrasileira/97-98-01-rt/uni1.jpg",
      "/images/selecaobrasileira/97-98-01-rt/uni2.jpg",
      "/images/selecaobrasileira/97-98-01-rt/uni3.jpg",
      "/images/selecaobrasileira/97-98-01-rt/uni4.jpg",
    ],
  },
  {
    id: 44,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 94/95 - Uniforme 1 Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/94-95-01-rt/uni0.jpg",
      "/images/selecaobrasileira/94-95-01-rt/uni1.jpg",
      "/images/selecaobrasileira/94-95-01-rt/uni2.jpg",
      "/images/selecaobrasileira/94-95-01-rt/uni3.jpg",
      "/images/selecaobrasileira/94-95-01-rt/uni4.jpg",
    ],
  },
  {
    id: 45,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 94/95 - Uniforme 2 Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/94-95-02-rt/uni0.jpg",
      "/images/selecaobrasileira/94-95-02-rt/uni1.jpg",
      "/images/selecaobrasileira/94-95-02-rt/uni2.jpg",
      "/images/selecaobrasileira/94-95-02-rt/uni3.jpg",
      "/images/selecaobrasileira/94-95-02-rt/uni4.jpg",
    ],
  },
  {
    id: 46,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 94/95 - Jaqueta (Branca)",
    aliases: [
      "brasil",
      "seleção",
      "jaqueta",
      "seleção brasileira",
      "canarinho",
      "jaqueta brasil",
      "brasil jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/94-95-05-jb/uni0.jpg",
      "/images/selecaobrasileira/94-95-05-jb/uni1.jpg",
      "/images/selecaobrasileira/94-95-05-jb/uni2.jpg",
      "/images/selecaobrasileira/94-95-05-jb/uni3.jpg",
      "/images/selecaobrasileira/94-95-05-jb/uni4.jpg",
    ],
  },
  {
    id: 47,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 91/92 - Uniforme 1 Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/91-92-01-rt/uni0.jpg",
      "/images/selecaobrasileira/91-92-01-rt/uni1.jpg",
      "/images/selecaobrasileira/91-92-01-rt/uni2.jpg",
      "/images/selecaobrasileira/91-92-01-rt/uni3.jpg",
      "/images/selecaobrasileira/91-92-01-rt/uni4.jpg",
    ],
  },
  {
    id: 48,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 92/93 - Uniforme 2 Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/91-92-02-rt/uni0.jpg",
      "/images/selecaobrasileira/91-92-02-rt/uni1.jpg",
      "/images/selecaobrasileira/91-92-02-rt/uni2.jpg",
      "/images/selecaobrasileira/91-92-02-rt/uni3.jpg",
      "/images/selecaobrasileira/91-92-02-rt/uni4.jpg",
    ],
  },
  {
    id: 49,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 85/86 - Uniforme 1 Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/85-86-01-rt/uni0.jpg",
      "/images/selecaobrasileira/85-86-01-rt/uni1.jpg",
      "/images/selecaobrasileira/85-86-01-rt/uni2.jpg",
      "/images/selecaobrasileira/85-86-01-rt/uni3.jpg",
      "/images/selecaobrasileira/85-86-01-rt/uni4.jpg",
    ],
  },
  {
    id: 50,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil 57/58 - Uniforme 2 Retrô",
    aliases: [
      "brasil",
      "seleção",
      "retro",
      "seleção retro",
      "seleção brasileira",
      "canarinho",
      "brasil retro",
      "retro brasil",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/selecaobrasileira/57-58-02-rt/uni0.jpg",
      "/images/selecaobrasileira/57-58-02-rt/uni1.jpg",
      "/images/selecaobrasileira/57-58-02-rt/uni2.jpg",
      "/images/selecaobrasileira/57-58-02-rt/uni3.jpg",
      "/images/selecaobrasileira/57-58-02-rt/uni4.jpg",
    ],
  },
  {
    id: 51,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil - Pré Jogo (Branca)",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/pjw/uni0.png",
      "/images/selecaobrasileira/pjw/uni1.png",
      "/images/selecaobrasileira/pjw/uni2.png",
      "/images/selecaobrasileira/pjw/uni3.png",
      "/images/selecaobrasileira/pjw/uni4.png",
    ],
  },
  {
    id: 52,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil - Pré Jogo (Verde)",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/pjg/uni0.png",
      "/images/selecaobrasileira/pjg/uni1.png",
      "/images/selecaobrasileira/pjg/uni2.png",
      "/images/selecaobrasileira/pjg/uni3.png",
      "/images/selecaobrasileira/pjg/uni4.png",
    ],
  },
  {
    id: 53,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil - Pré Jogo (Black)",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/pjb/uni0.png",
      "/images/selecaobrasileira/pjb/uni1.png",
      "/images/selecaobrasileira/pjb/uni2.png",
      "/images/selecaobrasileira/pjb/uni3.png",
      "/images/selecaobrasileira/pjb/uni4.png",
    ],
  },
  {
    id: 54,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil - Pré Jogo (Amarela)",
    aliases: ["brasil", "seleção", "seleção brasileira", "canarinho"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/pja/uni0.jpg",
      "/images/selecaobrasileira/pja/uni1.jpg",
      "/images/selecaobrasileira/pja/uni2.jpg",
      "/images/selecaobrasileira/pja/uni3.jpg",
      "/images/selecaobrasileira/pja/uni4.jpg",
    ],
  },
  {
    id: 55,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil - Jaqueta (Verde)",
    aliases: [
      "brasil",
      "seleção",
      "jaqueta",
      "seleção brasileira",
      "canarinho",
      "jaqueta brasil",
      "brasil jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/jv/uni0.jpg",
      "/images/selecaobrasileira/jv/uni1.jpg",
    ],
  },
  {
    id: 56,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil - Jaqueta (Preta)",
    aliases: [
      "brasil",
      "seleção",
      "jaqueta",
      "seleção brasileira",
      "canarinho",
      "jaqueta brasil",
      "brasil jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/jp/uni0.jpg",
      "/images/selecaobrasileira/jp/uni1.jpg",
      "/images/selecaobrasileira/jp/uni2.jpg",
      "/images/selecaobrasileira/jp/uni3.jpg",
      "/images/selecaobrasileira/jp/uni4.jpg",
    ],
  },
  {
    id: 57,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil - Jaqueta (Amarela)",
    aliases: [
      "brasil",
      "seleção",
      "jaqueta",
      "seleção brasileira",
      "canarinho",
      "jaqueta brasil",
      "brasil jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/ja/uni0.jpg",
      "/images/selecaobrasileira/ja/uni1.jpg",
    ],
  },
  {
    id: 58,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil - Blusa (Preta)",
    aliases: [
      "brasil",
      "seleção",
      "blusa",
      "seleção brasileira",
      "canarinho",
      "blusa brasil",
      "brasil blusa",
    ],
    tipo: "masculino",
    categoria: "blusa",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/bp/uni0.jpg",
      "/images/selecaobrasileira/bp/uni1.jpg",
      "/images/selecaobrasileira/bp/uni2.jpg",
      "/images/selecaobrasileira/bp/uni3.jpg",
      "/images/selecaobrasileira/bp/uni4.jpg",
    ],
  },
  {
    id: 59,
    pais: "brasil",
    liga: "serie-a",
    time: "selecao-brasileira",
    nome: "Brasil - Blusa (Azul)",
    aliases: [
      "brasil",
      "seleção",
      "blusa",
      "seleção brasileira",
      "canarinho",
      "blusa brasil",
      "brasil blusa",
    ],
    tipo: "masculino",
    categoria: "blusa",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/bta/uni0.jpg",
      "/images/selecaobrasileira/bta/uni1.jpg",
      "/images/selecaobrasileira/bta/uni2.jpg",
      "/images/selecaobrasileira/bta/uni3.jpg",
      "/images/selecaobrasileira/bta/uni4.jpg",
    ],
  },
];

export default brasil;
